var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreshold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F6F8FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7302 10.4239C26.0484 10.689 26.0914 11.1619 25.8262 11.4802L19.013 19.656C18.3633 20.4356 17.1888 20.5009 16.4567 19.7981L11.8182 15.3451C11.7079 15.2392 11.5294 15.2562 11.441 15.3809L7.86208 20.4335C7.62266 20.7715 7.15456 20.8515 6.81655 20.612C6.47854 20.3726 6.39862 19.9045 6.63804 19.5665L10.217 14.5139C10.8353 13.6409 12.0853 13.5221 12.857 14.263L17.4955 18.716C17.6001 18.8164 17.7679 18.8071 17.8607 18.6957L24.6739 10.5199C24.9391 10.2017 25.412 10.1587 25.7302 10.4239Z",
    fill: "#9DA1B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.05 17.75H5V16.25H6.05C6.46421 16.25 6.8 16.5858 6.8 17C6.8 17.4142 6.46421 17.75 6.05 17.75ZM7.4 17C7.4 16.5858 7.73579 16.25 8.15 16.25H10.25C10.6642 16.25 11 16.5858 11 17C11 17.4142 10.6642 17.75 10.25 17.75H8.15C7.73579 17.75 7.4 17.4142 7.4 17ZM11.6 17C11.6 16.5858 11.9358 16.25 12.35 16.25H14.45C14.8642 16.25 15.2 16.5858 15.2 17C15.2 17.4142 14.8642 17.75 14.45 17.75H12.35C11.9358 17.75 11.6 17.4142 11.6 17ZM15.8 17C15.8 16.5858 16.1358 16.25 16.55 16.25H18.65C19.0642 16.25 19.4 16.5858 19.4 17C19.4 17.4142 19.0642 17.75 18.65 17.75H16.55C16.1358 17.75 15.8 17.4142 15.8 17ZM20 17C20 16.5858 20.3358 16.25 20.75 16.25H22.85C23.2642 16.25 23.6 16.5858 23.6 17C23.6 17.4142 23.2642 17.75 22.85 17.75H20.75C20.3358 17.75 20 17.4142 20 17ZM24.2 17C24.2 16.5858 24.5358 16.25 24.95 16.25H26V17.75H24.95C24.5358 17.75 24.2 17.4142 24.2 17Z",
    fill: "#9DA1B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreshold);
export default __webpack_public_path__ + "static/media/threshold.fc966ebc4478dcc478344c804cbf2662.svg";
export { ForwardRef as ReactComponent };